module.exports = __webpack_public_path__ + "static/media/appleFruitOrange.20c54432.svg";